/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './ButtonClose.scss';
import { appIconsPath, getKeyByValue } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import Icons from '@core/Utils/Icons/Icons';

export function ButtonClose({
  onClick = () => {},
  icon = appIconsPath.CLOSE,
  isLightBtn = false,
  className = '',
  ...restProps
}) {
    const icosName = getKeyByValue(appIconsPath,icon);
  
  return (
    <button
      className={`${isLightBtn && 'btn-light'} ${className} border-0 bg-transparent btn`}
      aria-label="Close"
      type="button"
      onClick={onClick}
      {...restProps}>
      <Icons name={icosName} className="btn-close-icon" alt="close-button"  colorType='dark' />
    </button>
  );
}

ButtonClose.propTypes = {
  onClick: PropTypes.func,
  isLightBtn: PropTypes.bool,
  icon: PropTypes.string
};

export default ButtonClose;
